import apiClient from './apiClient';

const normalize = (o) => ({ ...o, status: o.status?.toLowerCase() });

export async function fetchOrganizations() {
  const { data } = await apiClient.get('/organizations');
  return data.map(normalize);
}

export async function addOrganization(payload) {
  const { data } = await apiClient.post('/organizations', payload);
  return normalize(data);
}

export async function updateOrganization(id, changes) {
  const payload = { ...changes };
  if (payload.status) payload.status = payload.status.toUpperCase();
  const { data } = await apiClient.patch(`/organizations/${id}`, payload);
  return normalize(data);
}
